import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-multiselect-custom',
    templateUrl: './multiselect-custom.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgSelectComponent, NgClass, FormsModule]
})
export class MultiselectCustomComponent {

  @Input() items: Array<{}> = [];
  @Input() bindLabel = 'name';
  @Input() bindValue = 'id';
  @Input() className = '';
  @Input() model: any;
  @Input() placeholder: any;
  @Output() changed = new EventEmitter();

  constructor() {}

}
